var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useLanguage } from '@base/LanguageProvider';
import { DocumentType, EntityPermissionsType } from '@common/api';
import FSButton from '@components/FSButton';
import { useActionsByDocumentId, useDeleteDocument, useDocuments, useDuplicateDocument, } from '@data/document/documentActions';
import EditDocument from '@main/dashboard/EditDocument';
import { ContextMenu } from '@shared/contextmenu';
import ShareModal from '@shared/finder/modals/ShareModal';
import { Copy, Delete, Edit, Plus, Share } from '@shared/icons/icons';
import Manager from '@shared/modal/Manager';
import { Confirmation } from '@shared/modal/Simple';
import React, { useRef, useState } from 'react';
import { AiOutlineLoading } from 'react-icons/ai';
import { FaChevronRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../providers/AuthProvider';
var TARGET_STYLE = { backgroundColor: '#e7eaf0' };
function ReportItem(_a) {
    var report = _a.report, menuTarget = _a.menuTarget, setMenuTarget = _a.setMenuTarget, currentReport = _a.currentReport;
    var navigate = useNavigate();
    var id = report.id, title = report.title;
    var reportContainerClass = currentReport && currentReport.id === report.id ? 'report-item__selected' : 'report-item';
    var style = menuTarget && menuTarget.id === report.id ? TARGET_STYLE : {};
    return (React.createElement("li", { key: "report".concat(id), className: reportContainerClass, onClick: function (e) {
            navigate('/dashboard/' + id);
        }, onContextMenu: function (e) { return setMenuTarget(report); }, style: style },
        React.createElement("div", { className: "select-indicator" }),
        React.createElement("h5", { className: "title" }, title)));
}
function FolderItem(_a) {
    var _b;
    var folder = _a.folder, documentMapByParentId = _a.documentMapByParentId, menuTarget = _a.menuTarget, setMenuTarget = _a.setMenuTarget, currentReport = _a.currentReport;
    var _c = __read(useState(true), 2), isExpanded = _c[0], setIsExpanded = _c[1];
    var folderItemClass = isExpanded ? 'folder-item__expanded' : 'folder-item';
    var style = menuTarget && menuTarget.id === folder.id ? TARGET_STYLE : {};
    //documentstodo - properly show subfolders
    return (React.createElement("li", { className: folderItemClass },
        React.createElement("div", { className: "folder", onClick: function () { return setIsExpanded(!isExpanded); }, onContextMenu: function (e) { return setMenuTarget(folder); }, style: style },
            React.createElement("div", { className: "content" },
                React.createElement("div", { className: "title-container" },
                    React.createElement("h5", { className: "title" }, folder.title))),
            React.createElement(FaChevronRight, { className: "folder-chevron" })),
        React.createElement("ul", { className: "reports-container" }, ((_b = documentMapByParentId.get(folder.id)) !== null && _b !== void 0 ? _b : [])
            .filter(function (d) { return d.type === DocumentType.REPORT; })
            .map(function (child) {
            return (React.createElement(ReportItem, { key: "report".concat(child.id), report: child, menuTarget: menuTarget, setMenuTarget: setMenuTarget, currentReport: currentReport }));
        }))));
}
//Temp
function SideMenu(_a) {
    var e_1, _b;
    var _c, _d, _e, _f;
    var onFolderAdd = _a.onFolderAdd, onReportAdd = _a.onReportAdd, currentReport = _a.currentReport;
    var menuItems = useRef(null);
    var L = useLanguage().L;
    var _g = __read(useState(null), 2), menuTarget = _g[0], setMenuTarget = _g[1];
    var documents = useDocuments();
    var documentActionsMap = useActionsByDocumentId();
    var duplicateDocument = useDuplicateDocument();
    var deleteDocument = useDeleteDocument();
    var user = useAuth().user;
    var navigate = useNavigate();
    var documentMapByParentId = new Map();
    try {
        for (var _h = __values((_c = documents.data) !== null && _c !== void 0 ? _c : []), _j = _h.next(); !_j.done; _j = _h.next()) {
            var document = _j.value;
            var children = documentMapByParentId.get(document.ParentId);
            if (!children) {
                children = [];
                documentMapByParentId.set(document.ParentId, children);
            }
            children.push(document);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
        }
        finally { if (e_1) throw e_1.error; }
    }
    var isReport = (menuTarget === null || menuTarget === void 0 ? void 0 : menuTarget.type) === DocumentType.REPORT;
    var duplicateHandler = function (e) {
        e.stopPropagation();
        if (!menuTarget) {
            return;
        }
        duplicateDocument.mutate({ srcId: menuTarget.id, destId: menuTarget.ParentId });
    };
    var addReportHandler = function (e) {
        e.stopPropagation();
        Manager.renderModal(React.createElement(EditDocument, { type: DocumentType.REPORT, ParentId: menuTarget === null || menuTarget === void 0 ? void 0 : menuTarget.id }));
    };
    var editHandler = function (e) {
        if (!menuTarget) {
            return;
        }
        e.stopPropagation();
        Manager.closeMenu();
        Manager.renderModal(React.createElement(EditDocument, { type: menuTarget.type, document: menuTarget }));
    };
    var shareHandler = function (e) {
        e.stopPropagation();
        if (!menuTarget) {
            return;
        }
        Manager.closeMenu();
        Manager.renderModal(React.createElement(ShareModal, { entity: EntityPermissionsType.Document, targetId: menuTarget.id }));
    };
    var deleteHandler = function (e) {
        e.stopPropagation();
        Manager.closeMenu();
        if (!menuTarget) {
            return;
        }
        var id = menuTarget.id, title = menuTarget.title;
        Manager.renderModal(React.createElement(Confirmation, { width: 400, title: React.createElement("span", null, L('Confirm delete operation')), onOk: function () {
                deleteDocument.mutate(id, {
                    onSuccess: function () {
                        if (currentReport && currentReport.id === id) {
                            navigate('/dashboard');
                        }
                    },
                });
            } },
            React.createElement("span", null,
                L('Are you sure you want to delete ' + (isReport ? 'report' : 'folder')),
                " ",
                React.createElement("b", null, title),
                " ",
                '?')));
    };
    var targetPerms = (menuTarget === null || menuTarget === void 0 ? void 0 : menuTarget.id) ? (_d = documentActionsMap.data) === null || _d === void 0 ? void 0 : _d[menuTarget.id] : undefined;
    return (React.createElement("div", { className: "menu-container" },
        documents.isLoading ? (React.createElement(AiOutlineLoading, { color: "grey", size: 20, style: {
                alignSelf: 'center',
                animation: 'spinicon 1s linear infinite',
            } })) : (React.createElement("ul", { ref: menuItems, className: "menu-items" }, (_e = documents.data) === null || _e === void 0 ? void 0 : _e.filter(function (d) { return d.type === DocumentType.FOLDER; }).filter(function (d) { return d.ParentId === null; }).map(function (folder) {
            return (React.createElement(FolderItem, { key: "folder".concat(folder.id), folder: folder, documentMapByParentId: documentMapByParentId, menuTarget: menuTarget, setMenuTarget: setMenuTarget, currentReport: currentReport }));
        }))),
        React.createElement(ContextMenu, { triggerRefs: [{ ref: menuItems }], onClose: function () { return setMenuTarget(null); }, items: [
                {
                    icon: Plus,
                    actionName: L('Add Report'),
                    isDisabled: !menuTarget || isReport || !(user === null || user === void 0 ? void 0 : user.classActions.documentClassActions.canCreate),
                    action: addReportHandler,
                    creative: true,
                },
                { spacer: true },
                {
                    icon: Edit,
                    actionName: L('Edit'),
                    isDisabled: !menuTarget || !(targetPerms === null || targetPerms === void 0 ? void 0 : targetPerms.canUpdate),
                    action: editHandler,
                },
                {
                    icon: Share,
                    actionName: L('Share'),
                    isDisabled: !(targetPerms === null || targetPerms === void 0 ? void 0 : targetPerms.canUpdate),
                    action: shareHandler,
                },
                {
                    icon: Copy,
                    actionName: L('Duplicate'),
                    isDisabled: !menuTarget || !isReport || !(user === null || user === void 0 ? void 0 : user.classActions.documentClassActions.canDuplicate),
                    action: duplicateHandler,
                },
                { spacer: true },
                {
                    icon: Delete,
                    actionName: L('Delete'),
                    isDisabled: !menuTarget || !(targetPerms === null || targetPerms === void 0 ? void 0 : targetPerms.canDelete),
                    destructive: true,
                    action: deleteHandler,
                },
            ] }),
        React.createElement("div", { className: "footer-wrapper" },
            React.createElement("div", { className: "footer-container" },
                React.createElement(FSButton, { title: L('Folder'), disabled: !(user === null || user === void 0 ? void 0 : user.classActions.documentClassActions.canCreate), className: "footer-button", "$type": "secondary", onClick: onFolderAdd }),
                React.createElement(FSButton, { title: L('Report'), disabled: !((_f = documents.data) === null || _f === void 0 ? void 0 : _f.length) || !(user === null || user === void 0 ? void 0 : user.classActions.documentClassActions.canCreate), className: "footer-button", onClick: onReportAdd })))));
}
export default SideMenu;
